import request, { ResponsePageableData } from '@/libs/request'

/** 积分商城订单列表 */
export const geOrderIntegralMallList = (data?) => request<ResponsePageableData>({ url: '/adminapi/OrderIntegralMall/getOrderList', data })
